(function () {
  window.__rebuyCartMetaVersion = window.__rebuyCartMetaVersion || 0;
  window.rebuyCartLeadTimes = window.rebuyCartLeadTimes || {};
  window.rebuyCartCompareAtPrices = window.rebuyCartCompareAtPrices || {};
  window.rebuyCartLinePricing = window.rebuyCartLinePricing || {};
  window.rebuyCartCustomTitles = window.rebuyCartCustomTitles || {};

  function isSmartCartEnabled() {
    return (
      typeof window.isSmartCartEnabled === 'function'
        ? window.isSmartCartEnabled()
        : document.body.classList.contains('smart-cart--enabled')
    );
  }

  function rebuyCartTryShow() {
    if (!isSmartCartEnabled()) return;

    const cartEl = document.getElementById('rebuy-cart');
    if (cartEl && cartEl.classList.contains('is-visible')) return;

    const smartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (!smartCart) return;

    if (typeof smartCart.show === 'function') {
      smartCart.show();
      return;
    }

    if (typeof smartCart.open === 'function') {
      smartCart.open();
    }
  }

  function toggleCartItemDetails(event) {
    const toggle = event.target.closest('.js-cart-item-details-toggle');
    if (!toggle || !toggle.closest('#rebuy-cart')) return;

    const details = toggle.nextElementSibling;
    if (!details || !details.classList.contains('js-cart-item-details')) return;

    event.preventDefault();
    const isOpen = details.classList.contains('js-open');
    details.classList.toggle('js-open', !isOpen);
    toggle.classList.toggle('js-toggled', !isOpen);
  }

  document.addEventListener('click', toggleCartItemDetails);

  document.addEventListener(
    'click',
    function (event) {
      if (!isSmartCartEnabled()) return;

      const target = event.target.closest('#rebuy-cart .rebuy-button, #rebuy-cart button, #rebuy-cart a');
      if (!target) return;

      const block = target.closest('.rebuy-product-block, .rebuy-product, [data-rebuy-product-id], [data-product-id]');
      if (!block || block.closest('[data-rebuy-component="cart-items"]')) return;

      rebuyCartCacheLeadTimeFromWidgetBlock(block);
      rebuyCartCacheCompareAtFromWidgetBlock(block);
      rebuyCartScheduleMetaSync([500, 1200, 2500, 5000]);
    },
    true
  );

  function rebuyCartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function rebuyCartVariantId(item) {
    if (!item) return null;

    const productId = rebuyCartProductId(item);
    const nestedVariantId =
      (item.variant && (item.variant.id || item.variant.variant_id || item.variant.variantId)) ||
      (item.selected_variant && (item.selected_variant.id || item.selected_variant.variant_id || item.selected_variant.variantId)) ||
      (item.selectedVariant && (item.selectedVariant.id || item.selectedVariant.variant_id || item.selectedVariant.variantId));

    if (item.variant_id || item.variantId || item.variantID) return item.variant_id || item.variantId || item.variantID;
    if (nestedVariantId) return nestedVariantId;
    if (item.id && (!productId || String(item.id) !== String(productId))) return item.id;

    return null;
  }

  window.rebuyCartFindVariantNode = function (variantId) {
    if (!variantId) return null;

    const id = String(variantId);
    return (
      document.querySelector('[data-variant-id="' + id + '"]') ||
      document.querySelector('option[data-variant-id="' + id + '"]') ||
      document.querySelector('.addon-product-variant-selector option[value="' + id + '"]') ||
      document.querySelector('.accessory-product-variant-selector option[value="' + id + '"]') ||
      document.querySelector('.optional-accessory-select[data-id="' + id + '"]') ||
      document.querySelector('.optional-accessory-select[data-default-id="' + id + '"]')
    );
  };

  function rebuyCartParseMoney(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

    const text = String(value).trim();
    let amount = parseFloat(text.replace(/,/g, '').replace(/[^0-9.]/g, '')) || 0;
    if (amount && amount < 10000 && (text.includes('$') || text.includes(',') || /\.\d{1,2}\b/.test(text))) {
      amount = Math.round(amount * 100);
    }

    return amount;
  }

  function rebuyCartNormalizeCompareAt(compareAt, unitPrice) {
    if (compareAt && unitPrice && compareAt < unitPrice && compareAt * 100 > unitPrice) {
      return compareAt * 100;
    }

    return compareAt;
  }

  function rebuyCartCacheVariantValue(map, variantId, value) {
    if (!map || !variantId || value == null || value === '') return;
    map[variantId] = value;
    map['v:' + String(variantId)] = value;
  }

  function rebuyCartLeadTimeForVariant(variantId) {
    if (!variantId) return '';

    const leadTimes = window.rebuyCartLeadTimes || {};
    const leadTime = leadTimes[variantId] || leadTimes['v:' + String(variantId)] || '';

    return String(leadTime || '').trim();
  }

  function rebuyCartVisibleCartItems() {
    const cart = window.__rebuyShopifyCart;
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items.filter(function (item) {
      const properties = item && item.properties;
      return !(properties && (properties._hidden || properties.__hidden));
    });
  }

  function rebuyCartVariantIdForRow(row, index) {
    const cartItem = rebuyCartVisibleCartItems()[index];
    const cartVariantId = rebuyCartVariantId(cartItem);
    if (cartVariantId) {
      if (row) row.setAttribute('data-rebuy-variant-id', String(cartVariantId));
      return cartVariantId;
    }

    const rowVariantId = row && row.getAttribute('data-rebuy-variant-id');
    if (rowVariantId) return rowVariantId;

    return null;
  }

  function rebuyCartEscapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function rebuyCartTextKey(value) {
    if (window.rebuyCartTextKey && window.rebuyCartTextKey !== rebuyCartTextKey) {
      return window.rebuyCartTextKey(value);
    }

    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  window.rebuyCartTextKey = window.rebuyCartTextKey || rebuyCartTextKey;

  function rebuyCartProductId(item) {
    if (!item) return null;
    return item.product_id || item.productId || item.productID || (item.product && item.product.id) || null;
  }

  function rebuyCartHandle(item) {
    if (!item) return '';
    return item.handle || item.product_handle || item.productHandle || (item.product && item.product.handle) || '';
  }

  function rebuyCartProductTitle(item) {
    if (!item) return '';

    let title = item.product_title || item.productTitle || (item.product && item.product.title) || item.title || '';
    const variantTitle = item.variant_title || item.variantTitle || (item.variant && item.variant.title);

    if (title && variantTitle) {
      const variantSuffix = ' - ' + variantTitle;
      if (String(title).slice(-variantSuffix.length) === variantSuffix) {
        title = String(title).slice(0, -variantSuffix.length);
      }
    }

    return title;
  }

  window.rebuyCartProductTitle = window.rebuyCartProductTitle || rebuyCartProductTitle;

  function rebuyCartCacheCompareAtAliases(meta) {
    if (!meta || !meta.compareAt) return false;

    let compareAt = rebuyCartParseMoney(meta.compareAt);
    const unitPrice = rebuyCartParseMoney(meta.price || meta.salePrice || 0);

    compareAt = rebuyCartNormalizeCompareAt(compareAt, unitPrice);

    if (!compareAt || (unitPrice && compareAt <= unitPrice)) return false;

    const compareAtPrices = window.rebuyCartCompareAtPrices;
    const variantId = meta.variantId;
    const productId = meta.productId;
    const handle = meta.handle;
    const titleKey = rebuyCartTextKey(meta.title);

    if (variantId) rebuyCartCacheVariantValue(compareAtPrices, variantId, compareAt);
    if (productId) compareAtPrices['p:' + String(productId)] = compareAt;
    if (handle) compareAtPrices['h:' + String(handle)] = compareAt;
    if (titleKey) compareAtPrices['t:' + titleKey] = compareAt;

    return !!(variantId || productId || handle || titleKey);
  }

  function rebuyCartCachedCompareAtForItem(item) {
    if (!item) return 0;

    const compareAtPrices = window.rebuyCartCompareAtPrices || {};
    const variantId = rebuyCartVariantId(item);
    const productId = rebuyCartProductId(item);
    const handle = rebuyCartHandle(item);
    const titleKey = rebuyCartTextKey(rebuyCartProductTitle(item));
    const candidates = [
      variantId && compareAtPrices[variantId],
      variantId && compareAtPrices['v:' + String(variantId)],
      productId && compareAtPrices['p:' + String(productId)],
      handle && compareAtPrices['h:' + String(handle)],
      titleKey && compareAtPrices['t:' + titleKey],
    ];

    for (const candidate of candidates) {
      const value = rebuyCartParseMoney(candidate);
      if (value) return value;
    }

    return 0;
  }

  function rebuyCartExtractId(value) {
    if (value == null || value === '') return '';
    const match = String(value).match(/\d{5,}/);
    return match ? match[0] : String(value);
  }

  function rebuyCartFindAttribute(root, names) {
    if (!root) return '';

    const nodes = [root].concat(Array.from(root.querySelectorAll('*')));
    for (const node of nodes) {
      for (const name of names) {
        const value = node.getAttribute && node.getAttribute(name);
        if (value) return value;
      }
    }

    return '';
  }

  function rebuyCartMoneyValuesFromText(text) {
    const matches = String(text || '').match(/\$?\s*\d[\d,]*(?:\.\d{1,2})?/g) || [];
    return matches
      .map(function (match) {
        return rebuyCartParseMoney(match);
      })
      .filter(Boolean);
  }

  function rebuyCartCacheCompareAtFromWidgetBlock(block) {
    if (!block) return false;

    const priceRoot = block.querySelector('.rebuy-product-price') || block;
    const compareNode = priceRoot.querySelector('.rebuy-money.compare-at, .compare-at, .rebuy-compare-price, .rebuy-product-compare-price, del, s');
    const saleNode = priceRoot.querySelector('.rebuy-money.sale, .sale, .rebuy-sale-price, ins');
    let compareAt = compareNode ? rebuyCartParseMoney(compareNode.textContent) : 0;
    let salePrice = saleNode ? rebuyCartParseMoney(saleNode.textContent) : 0;

    if (!compareAt) {
      const prices = rebuyCartMoneyValuesFromText(priceRoot.textContent);
      if (prices.length > 1) {
        compareAt = Math.max.apply(Math, prices);
        salePrice = Math.min.apply(Math, prices);
      }
    }

    if (!compareAt || (salePrice && compareAt <= salePrice)) return false;

    const titleNode = block.querySelector('.rebuy-product-title-link, .rebuy-product-title, [data-product-title]');
    const linkNode = block.querySelector('a[href*="/products/"]');
    const linkHref = linkNode && linkNode.getAttribute('href');
    const handleMatch = linkHref && linkHref.match(/\/products\/([^/?#]+)/);
    const title = (titleNode && titleNode.textContent && titleNode.textContent.trim()) || '';
    const variantId = rebuyCartExtractId(
      rebuyCartFindAttribute(block, [
        'data-variant-id',
        'data-rebuy-variant-id',
        'data-selected-variant-id',
        'data-product-variant-id',
      ])
    );
    const productId = rebuyCartExtractId(
      rebuyCartFindAttribute(block, ['data-product-id', 'data-rebuy-product-id', 'data-productid'])
    );
    const handle =
      rebuyCartFindAttribute(block, ['data-product-handle', 'data-handle']) ||
      (handleMatch && decodeURIComponent(handleMatch[1])) ||
      '';

    return rebuyCartCacheCompareAtAliases({
      compareAt,
      price: salePrice,
      variantId,
      productId,
      handle,
      title,
    });
  }

  function rebuyCartCacheLeadTimeAliases(meta) {
    if (!meta || !meta.variantId || !meta.leadTime) return false;

    const leadTime = String(meta.leadTime || '').trim();
    if (!leadTime) return false;

    rebuyCartCacheVariantValue(window.rebuyCartLeadTimes, meta.variantId, leadTime);
    return true;
  }

  function rebuyCartCacheLeadTimeFromWidgetBlock(block) {
    if (!block) return false;

    const variantId = rebuyCartExtractId(
      rebuyCartFindAttribute(block, [
        'data-variant-id',
        'data-rebuy-variant-id',
        'data-selected-variant-id',
        'data-product-variant-id',
      ])
    );
    const leadTime = rebuyCartFindAttribute(block, ['data-lead-time', 'data-rebuy-lead-time']);

    return rebuyCartCacheLeadTimeAliases({ variantId, leadTime });
  }

  function rebuyCartValueFromPath(source, path) {
    return path.reduce(function (current, key) {
      if (current == null) return null;
      return current[key];
    }, source);
  }

  function rebuyCartLeadTimeFromObject(value) {
    if (window.rebuyCartVariantLeadTime && window.rebuyCartVariantLeadTime !== rebuyCartLeadTimeFromObject) {
      const variantLeadTime = window.rebuyCartVariantLeadTime(value);
      if (variantLeadTime) return variantLeadTime;
    }

    const paths = [
      ['lead_time'],
      ['leadTime'],
      ['variant', 'lead_time'],
      ['variant', 'leadTime'],
      ['variant', 'metafields', 'custom', 'lead_time'],
      ['variant', 'metafields', 'lead_time'],
      ['selected_variant', 'lead_time'],
      ['selected_variant', 'leadTime'],
      ['selected_variant', 'metafields', 'custom', 'lead_time'],
      ['selected_variant', 'metafields', 'lead_time'],
    ];

    for (const path of paths) {
      let valueAtPath = rebuyCartValueFromPath(value, path);
      if (valueAtPath && typeof valueAtPath === 'object' && valueAtPath.value) valueAtPath = valueAtPath.value;
      valueAtPath = String(valueAtPath || '').trim();
      if (valueAtPath) return valueAtPath;
    }

    return '';
  }

  function rebuyCartVariantIdFromLeadSource(value) {
    if (!value || typeof value !== 'object') return null;

    return (
      value.variant_id ||
      value.variantId ||
      value.variantID ||
      (value.variant && (value.variant.id || value.variant.variant_id || value.variant.variantId)) ||
      (value.selected_variant && (value.selected_variant.id || value.selected_variant.variant_id || value.selected_variant.variantId)) ||
      (value.selectedVariant && (value.selectedVariant.id || value.selectedVariant.variant_id || value.selectedVariant.variantId)) ||
      null
    );
  }

  function rebuyCartCacheLeadTimeFromSource(source) {
    if (!source || typeof source !== 'object') return false;

    const seen = new WeakSet();
    let found = false;

    function visit(value, depth) {
      if (!value || typeof value !== 'object' || depth > 5 || seen.has(value)) return;
      seen.add(value);

      const leadTime = rebuyCartLeadTimeFromObject(value);
      if (leadTime) {
        found =
          rebuyCartCacheLeadTimeAliases({
            leadTime,
            variantId: rebuyCartVariantIdFromLeadSource(value),
          }) || found;
      }

      if (Array.isArray(value)) {
        value.forEach(function (entry) {
          visit(entry, depth + 1);
        });
        return;
      }

      Object.keys(value).forEach(function (key) {
        if (/element|target|node|event/i.test(key)) return;
        visit(value[key], depth + 1);
      });
    }

    visit(source, 0);
    return found;
  }

  function rebuyCartCacheCompareAtFromSource(source) {
    if (!source || typeof source !== 'object') return false;

    const seen = new WeakSet();
    let found = false;

    function visit(value, depth) {
      if (!value || typeof value !== 'object' || depth > 5 || seen.has(value)) return;
      seen.add(value);

      const compareAt =
        value.compare_at_price ||
        value.compareAtPrice ||
        value.compare_at ||
        value.compareAt ||
        value.original_compare_at_price ||
        value.originalCompareAtPrice ||
        (value.variant &&
          (value.variant.compare_at_price || value.variant.compareAtPrice || value.variant.compare_at || value.variant.compareAt)) ||
        (value.selected_variant &&
          (value.selected_variant.compare_at_price ||
            value.selected_variant.compareAtPrice ||
            value.selected_variant.compare_at ||
            value.selected_variant.compareAt));

      if (compareAt) {
        found =
          rebuyCartCacheCompareAtAliases({
            compareAt,
            price:
              value.price ||
              value.sale_price ||
              value.salePrice ||
              value.discounted_price ||
              value.discountedPrice ||
              value.final_price ||
              value.finalPrice ||
              (value.variant && (value.variant.price || value.variant.final_price || value.variant.finalPrice)) ||
              (value.selected_variant &&
                (value.selected_variant.price || value.selected_variant.final_price || value.selected_variant.finalPrice)),
            variantId:
              rebuyCartVariantId(value) ||
              (value.selected_variant && (value.selected_variant.id || value.selected_variant.variant_id)),
            productId: rebuyCartProductId(value),
            handle: rebuyCartHandle(value),
            title: rebuyCartProductTitle(value),
          }) || found;
      }

      if (Array.isArray(value)) {
        value.forEach(function (entry) {
          visit(entry, depth + 1);
        });
        return;
      }

      Object.keys(value).forEach(function (key) {
        if (/element|target|node|event/i.test(key)) return;
        visit(value[key], depth + 1);
      });
    }

    visit(source, 0);
    return found;
  }

  function rebuyCartPublicPropertiesKey(item) {
    const properties = (item && item.properties) || {};
    const keys = Object.keys(properties).filter(function (key) {
      const value = properties[key];
      return key.charAt(0) !== '_' && value != null && value !== '';
    });

    return keys
      .sort()
      .map(function (key) {
        return key + ':' + String(properties[key]);
      })
      .join('|');
  }

  function rebuyCartPropertyCount(item) {
    const properties = (item && item.properties) || {};
    return Object.keys(properties).filter(function (key) {
      const value = properties[key];
      return value != null && value !== '';
    }).length;
  }

  function rebuyCartSellingPlanKey(item) {
    const allocation = item && item.selling_plan_allocation;
    const sellingPlan = allocation && allocation.selling_plan;

    return (
      item.selling_plan ||
      (sellingPlan && (sellingPlan.id || sellingPlan.name)) ||
      ''
    );
  }

  function rebuyCartMergeGroupKey(item) {
    const variantId = rebuyCartVariantId(item);
    if (!variantId) return '';

    return [variantId, rebuyCartSellingPlanKey(item), rebuyCartPublicPropertiesKey(item)].join('::');
  }

  function rebuyCartBuildDuplicateMergeUpdates(cart) {
    const groups = {};

    if (!cart || !Array.isArray(cart.items)) return null;

    cart.items.forEach(function (item) {
      const key = rebuyCartMergeGroupKey(item);
      if (!key) return;

      groups[key] = groups[key] || [];
      groups[key].push(item);
    });

    const updates = {};
    let hasUpdates = false;

    Object.keys(groups).forEach(function (key) {
      const lines = groups[key];
      if (lines.length < 2) return;

      const totalQuantity = lines.reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);
      const canonical = lines.slice().sort(function (a, b) {
        return rebuyCartPropertyCount(a) - rebuyCartPropertyCount(b);
      })[0];

      lines.forEach(function (item) {
        if (!item.key) return;

        if (item.key === canonical.key) {
          if (Number(item.quantity || 0) !== totalQuantity) {
            updates[item.key] = totalQuantity;
            hasUpdates = true;
          }
          return;
        }

        updates[item.key] = 0;
        hasUpdates = true;
      });
    });

    return hasUpdates ? updates : null;
  }

  function rebuyCartNotifyCartUpdated(cart) {
    window.__rebuyShopifyCart = cart;

    const rebuyCart = window.Rebuy && window.Rebuy.Cart;
    const smartCart = window.Rebuy && window.Rebuy.SmartCart;
    const refreshers = [
      { target: rebuyCart, fn: rebuyCart && rebuyCart.fetch },
      { target: rebuyCart, fn: rebuyCart && rebuyCart.refresh },
      { target: smartCart, fn: smartCart && smartCart.fetch },
      { target: smartCart, fn: smartCart && smartCart.refresh },
      { target: smartCart, fn: smartCart && smartCart.update },
    ];

    refreshers.some(function (refresher) {
      if (!refresher || typeof refresher.fn !== 'function') return false;

      try {
        refresher.fn.call(refresher.target);
        return true;
      } catch (error) {
        return false;
      }
    });

    window.rebuyCartRefreshView();
  }

  let rebuyCartMergeInFlight = null;

  window.rebuyCartMergeDuplicateLines = function () {
    if (!isSmartCartEnabled()) return Promise.resolve(false);
    if (rebuyCartMergeInFlight) return rebuyCartMergeInFlight;

    rebuyCartMergeInFlight = fetch(rebuyCartRoot() + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        const updates = rebuyCartBuildDuplicateMergeUpdates(cart);
        if (!updates) return false;

        return fetch(rebuyCartRoot() + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ updates }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (updatedCart) {
            rebuyCartNotifyCartUpdated(updatedCart);
            return true;
          });
      })
      .catch(function (error) {
        console.warn('Unable to merge duplicate rebuy cart lines', error);
        return false;
      })
      .finally(function () {
        rebuyCartMergeInFlight = null;
      });

    return rebuyCartMergeInFlight;
  };

  window.rebuyCartCacheLeadTimeFromDom = function (item) {
    const variantId = rebuyCartVariantId(item);
    if (!variantId || window.rebuyCartLeadTimes[variantId] || window.rebuyCartLeadTimes['v:' + String(variantId)]) return false;

    const node = window.rebuyCartFindVariantNode(variantId);
    const leadTime = node && node.getAttribute('data-lead-time');
    if (!leadTime) return false;

    rebuyCartCacheVariantValue(window.rebuyCartLeadTimes, variantId, leadTime);
    return true;
  };

  window.rebuyCartCacheCompareAtFromDom = function (item) {
    const variantId = rebuyCartVariantId(item);
    if (!variantId) return false;

    const node = window.rebuyCartFindVariantNode(variantId);
    const comparePrice = node && (node.getAttribute('data-compare-price') || node.dataset.comparePrice);
    if (!comparePrice) return false;

    const parsed = rebuyCartParseMoney(comparePrice);
    if (!parsed) return false;

    rebuyCartCacheVariantValue(window.rebuyCartCompareAtPrices, variantId, parsed);
    return true;
  };

  function rebuyCartLinkTitleKeys(lineItem) {
    if (!lineItem) return;

    const titles = window.rebuyCartCustomTitles;
    if (!titles) return;

    const productId = lineItem.product_id;
    const variantId = lineItem.variant_id;
    const handle = lineItem.handle;
    const resolvedTitle =
      titles['v:' + variantId] ||
      titles[String(productId)] ||
      titles[productId] ||
      (handle && titles['h:' + handle]);

    if (!resolvedTitle) return;

    if (variantId != null) titles['v:' + String(variantId)] = resolvedTitle;
    if (productId != null) titles[String(productId)] = resolvedTitle;
    if (handle) titles['h:' + String(handle)] = resolvedTitle;
  }

  window.rebuyCartCacheCompareAtFromCartItem = function (lineItem) {
    if (!lineItem) return false;

    const variantId = rebuyCartVariantId(lineItem);
    const unitPrice = rebuyCartParseMoney(lineItem.price || lineItem.original_price || lineItem.final_price || 0);
    let compareAt = rebuyCartParseMoney(
      lineItem.compare_at_price ||
        lineItem.compareAtPrice ||
        lineItem.compare_at_price_cents ||
        (lineItem.variant && (lineItem.variant.compare_at_price || lineItem.variant.compareAtPrice || lineItem.variant.compare_at_price_cents)) ||
        0
    );

    if (!compareAt) compareAt = rebuyCartCachedCompareAtForItem(lineItem);
    if (!variantId || !compareAt) return false;
    compareAt = rebuyCartNormalizeCompareAt(compareAt, unitPrice);
    if (unitPrice && compareAt <= unitPrice) return false;

    rebuyCartCacheVariantValue(window.rebuyCartCompareAtPrices, variantId, compareAt);
    return true;
  };

  window.rebuyCartSeedPageCatalog = function () {
    let found = false;

    document.querySelectorAll('[data-variant-id]').forEach(function (node) {
      const variantId = node.getAttribute('data-variant-id');
      const leadTime = node.getAttribute('data-lead-time');
      const comparePrice = node.getAttribute('data-compare-price');

      if (variantId && leadTime) {
        rebuyCartCacheVariantValue(window.rebuyCartLeadTimes, variantId, leadTime);
        found = true;
      }
      if (variantId && comparePrice) {
        const parsed = rebuyCartParseMoney(comparePrice);
        if (parsed) {
          rebuyCartCacheVariantValue(window.rebuyCartCompareAtPrices, variantId, parsed);
          found = true;
        }
      }
    });

    document
      .querySelectorAll('.addon-product-variant-selector option[value], .accessory-product-variant-selector option[value]')
      .forEach(function (option) {
        const variantId = option.value;
        const comparePrice = option.getAttribute('data-compare-price');
        const leadTime = option.getAttribute('data-lead-time');
        if (!variantId) return;

        if (comparePrice) {
          const parsed = rebuyCartParseMoney(comparePrice);
          if (parsed) {
            rebuyCartCacheVariantValue(window.rebuyCartCompareAtPrices, variantId, parsed);
            found = true;
          }
        }

        if (leadTime) {
          rebuyCartCacheVariantValue(window.rebuyCartLeadTimes, variantId, leadTime);
          found = true;
        }
      });

    document.querySelectorAll('.optional-accessory-select').forEach(function (input) {
      const variantId = input.getAttribute('data-id') || input.getAttribute('data-default-id');
      const comparePrice = input.getAttribute('data-compare-price') || input.getAttribute('data-default-compare-price');
      const leadTime = input.getAttribute('data-lead-time') || input.getAttribute('data-default-lead-time');
      if (!variantId) return;

      if (comparePrice) {
        const parsed = rebuyCartParseMoney(comparePrice);
        if (parsed) {
          rebuyCartCacheVariantValue(window.rebuyCartCompareAtPrices, variantId, parsed);
          found = true;
        }
      }

      if (leadTime) {
        rebuyCartCacheVariantValue(window.rebuyCartLeadTimes, variantId, leadTime);
        found = true;
      }
    });

    document.querySelectorAll('#rebuy-cart .rebuy-product-block, #rebuy-cart .rebuy-product').forEach(function (block) {
      found = rebuyCartCacheLeadTimeFromWidgetBlock(block) || found;
      found = rebuyCartCacheCompareAtFromWidgetBlock(block) || found;
    });

    return found;
  };

  window.rebuyCartLineItemKey = function (item, index) {
    const variantId = rebuyCartVariantId(item) || (item && item.key) || index;
    return String(variantId) + '-' + String(window.__rebuyCartMetaVersion || 0);
  };

  window.rebuyCartRefreshView = function () {
    const smartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (!smartCart) return;

    if (typeof smartCart.$forceUpdate === 'function') {
      smartCart.$forceUpdate();
      return;
    }

    if (smartCart.vue && typeof smartCart.vue.$forceUpdate === 'function') {
      smartCart.vue.$forceUpdate();
      return;
    }

    if (smartCart.vue && smartCart.vue.proxy && typeof smartCart.vue.proxy.$forceUpdate === 'function') {
      smartCart.vue.proxy.$forceUpdate();
    }
  };

  function rebuyCartRenderLeadTimes() {
    const cart = document.getElementById('rebuy-cart');
    if (!cart) return;

    cart.querySelectorAll('[data-rebuy-component="cart-items"] .rebuy-cart__flyout-item').forEach(function (row, index) {
      const variantId = rebuyCartVariantIdForRow(row, index);
      const leadTime = rebuyCartLeadTimeForVariant(variantId);
      const currentMeta = row.querySelector('.cart-item--lead-time-meta');

      if (!leadTime) {
        if (currentMeta && currentMeta.getAttribute('data-rebuy-rendered-lead-time') === 'true') currentMeta.remove();
        return;
      }

      if (currentMeta) {
        const valueNode = currentMeta.querySelector('[data-rebuy-lead-time-value]') || currentMeta.querySelector('.cart-item--lead-time span:last-child');
        if (valueNode) valueNode.textContent = leadTime;
        return;
      }

      const details = row.querySelector('.js-cart-item-details');
      const content = row.querySelector('.cart-item__details-content');
      const html =
        '<div class="cart-item--lead-time-meta" data-rebuy-rendered-lead-time="true">' +
        '<p class="cart-item--lead-time"><span>Order Processing:</span> ' +
        '<span data-rebuy-lead-time-value>' +
        rebuyCartEscapeHtml(leadTime) +
        '</span></p></div>';

      if (details) {
        details.insertAdjacentHTML('afterend', html);
      } else if (content) {
        content.insertAdjacentHTML('beforebegin', html);
      }
    });
  }

  function rebuyCartScheduleLeadTimeRender() {
    rebuyCartRenderLeadTimes();
    requestAnimationFrame(rebuyCartRenderLeadTimes);
    window.setTimeout(rebuyCartRenderLeadTimes, 150);
  }

  function rebuyCartMarkMetaSynced() {
    window.__rebuyCartMetaVersion += 1;

    const cart = document.getElementById('rebuy-cart');
    if (cart) {
      cart.setAttribute('data-meta-version', String(window.__rebuyCartMetaVersion));
    }

    window.rebuyCartRefreshView();
    rebuyCartScheduleLeadTimeRender();
  }

  function rebuyCartApplyMeta(meta) {
    if (!meta) return;

    if (meta.titles) window.rebuyCartCustomTitles = Object.assign({}, window.rebuyCartCustomTitles || {}, meta.titles);
    if (meta.leadTimes) window.rebuyCartLeadTimes = Object.assign({}, window.rebuyCartLeadTimes || {}, meta.leadTimes);
    if (meta.compareAtPrices) {
      window.rebuyCartCompareAtPrices = Object.assign({}, window.rebuyCartCompareAtPrices || {}, meta.compareAtPrices);
    }
    if (meta.linePricing) window.rebuyCartLinePricing = Object.assign({}, window.rebuyCartLinePricing || {}, meta.linePricing);
  }

  function rebuyCartScheduleMetaSync(delays) {
    if (!Array.isArray(delays)) delays = [300, 900];

    delays.forEach(function (delay) {
      window.setTimeout(function () {
        if (!isSmartCartEnabled()) return;
        window.syncRebuyCartMeta();
      }, delay);
    });
  }

  let activeSync = null;

  window.syncRebuyCartMeta = function () {
    if (!isSmartCartEnabled()) {
      return Promise.resolve();
    }

    const cacheBust = Date.now();

    activeSync = Promise.all([
      fetch(rebuyCartRoot() + 'cart?sections=rebuy-cart-meta&_rebuy_meta=' + cacheBust, { cache: 'no-store' })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          const payload = data && data['rebuy-cart-meta'];
          if (!payload) return;

          try {
            rebuyCartApplyMeta(JSON.parse(payload.trim()));
          } catch (error) {
            console.warn('Unable to parse rebuy cart meta data', error);
          }
        }),
      fetch(rebuyCartRoot() + 'cart.js?_rebuy_meta=' + cacheBust, { cache: 'no-store' })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          window.__rebuyShopifyCart = cart;
          if (cart && cart.items) {
            cart.items.forEach(function (lineItem) {
              window.rebuyCartCacheCompareAtFromCartItem(lineItem);
              rebuyCartLinkTitleKeys(lineItem);
            });
          }
        }),
    ])
      .catch(function (error) {
        console.warn('Unable to sync rebuy cart meta', error);
      })
      .then(function () {
        rebuyCartMarkMetaSynced();
      });

    return activeSync;
  };

  function rebuyCartPrimeItemMeta(item) {
    if (!item) return false;

    let found = false;
    found = window.rebuyCartCacheLeadTimeFromDom(item) || found;
    found = window.rebuyCartCacheCompareAtFromDom(item) || found;
    found = window.rebuyCartCacheCompareAtFromCartItem(item) || found;

    return found;
  }

  window.rebuyCartAfterThemeAdd = function (variantIds) {
    if (!isSmartCartEnabled()) {
      return Promise.resolve();
    }

    let foundMeta = window.rebuyCartSeedPageCatalog();

    if (variantIds) {
      if (!Array.isArray(variantIds)) variantIds = [variantIds];

      variantIds.forEach(function (variantId) {
        foundMeta = rebuyCartPrimeItemMeta({ variant_id: variantId }) || foundMeta;
      });
    }

    if (foundMeta) rebuyCartMarkMetaSynced();

    return window.rebuyCartMergeDuplicateLines()
      .then(function () {
        return window.syncRebuyCartMeta();
      })
      .then(function () {
        rebuyCartTryShow();
        rebuyCartScheduleMetaSync([300, 900, 2000]);
      });
  };

  function rebuyCartHandleCartChange(event) {
    let foundMeta = rebuyCartCacheLeadTimeFromSource(event && event.detail);
    foundMeta = rebuyCartCacheCompareAtFromSource(event && event.detail) || foundMeta;

    const shopifyCart = event && event.detail && event.detail.cart && event.detail.cart.cart;

    if (shopifyCart) {
      window.__rebuyShopifyCart = shopifyCart;
      if (shopifyCart.items) {
        shopifyCart.items.forEach(function (lineItem) {
          foundMeta = rebuyCartPrimeItemMeta(lineItem) || foundMeta;
        });
      }
    }

    foundMeta = window.rebuyCartSeedPageCatalog() || foundMeta;
    if (foundMeta) rebuyCartMarkMetaSynced();
    return window.rebuyCartMergeDuplicateLines()
      .then(function () {
        return window.syncRebuyCartMeta();
      })
      .then(function () {
        rebuyCartScheduleMetaSync([300, 900, 2000]);
      });
  }

  document.addEventListener('rebuy:cart.add', function (event) {
    if (!isSmartCartEnabled()) return;

    let foundMeta = rebuyCartCacheLeadTimeFromSource(event.detail);
    foundMeta = rebuyCartCacheCompareAtFromSource(event.detail) || foundMeta;
    foundMeta = rebuyCartPrimeItemMeta(event.detail && event.detail.item) || foundMeta;
    foundMeta = window.rebuyCartSeedPageCatalog() || foundMeta;
    if (foundMeta) rebuyCartMarkMetaSynced();
    window.rebuyCartMergeDuplicateLines().then(function () {
      window.syncRebuyCartMeta();
      rebuyCartScheduleMetaSync([300, 900, 2000]);
    });
  });

  document.addEventListener('rebuy:cart.change', function (event) {
    if (!isSmartCartEnabled()) return;
    rebuyCartHandleCartChange(event);
  });

  document.addEventListener('rebuy:smartcart.show', function () {
    if (!isSmartCartEnabled()) return;
    saveScrollPosition();
    if (window.rebuyCartSeedPageCatalog()) rebuyCartMarkMetaSynced();
    window.rebuyCartMergeDuplicateLines().then(function () {
      window.syncRebuyCartMeta();
      rebuyCartScheduleMetaSync([400, 1000, 2500]);
    });
  });

  document.addEventListener('rebuy:smartcart.ready', function () {
    document.body.classList.add('smart-cart--enabled');
    if (window.rebuyCartSeedPageCatalog()) rebuyCartMarkMetaSynced();
    window.rebuyCartMergeDuplicateLines().then(function () {
      window.syncRebuyCartMeta();
      rebuyCartScheduleMetaSync([400, 1000, 2500]);
    });
    initCartVisibilityObserver();
  });

  if (document.getElementById('rebuy-cart')) {
    window.rebuyCartSeedPageCatalog();
  }

  let savedScrollY = 0;
  let cartWasVisible = false;
  let restoreFrame = 0;

  function readScrollY() {
    if (document.body.style.position === 'fixed') {
      const top = parseInt(document.body.style.top, 10);
      if (!Number.isNaN(top)) return Math.abs(top);
    }

    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function saveScrollPosition() {
    savedScrollY = readScrollY();
  }

  function clearBodyLockStyles() {
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
    document.documentElement.style.removeProperty('overflow');
  }

  function restoreScrollPosition() {
    const scrollY = savedScrollY;

    if (restoreFrame) cancelAnimationFrame(restoreFrame);

    restoreFrame = requestAnimationFrame(function () {
      clearBodyLockStyles();
      window.scrollTo(0, scrollY);

      restoreFrame = requestAnimationFrame(function () {
        if (Math.abs(readScrollY() - scrollY) > 2) {
          window.scrollTo(0, scrollY);
        }
        restoreFrame = 0;
      });
    });
  }

  document.addEventListener('rebuy:smartcart.hide', function () {
    if (!isSmartCartEnabled()) return;
    restoreScrollPosition();
  });

  function initCartVisibilityObserver() {
    if (!isSmartCartEnabled()) return;

    const cart = document.getElementById('rebuy-cart');
    if (!cart || cart.dataset.scrollObserverInit === 'true') return;

    cart.dataset.scrollObserverInit = 'true';

    const observer = new MutationObserver(function () {
      const isVisible = cart.classList.contains('is-visible');

      if (isVisible && !cartWasVisible) saveScrollPosition();
      if (!isVisible && cartWasVisible) restoreScrollPosition();

      cartWasVisible = isVisible;
    });

    observer.observe(cart, { attributes: true, attributeFilter: ['class'] });
    cartWasVisible = cart.classList.contains('is-visible');
  }

  function initCartLeadTimeObserver() {
    const cart = document.getElementById('rebuy-cart');
    if (!cart || cart.dataset.leadTimeObserverInit === 'true') return;

    cart.dataset.leadTimeObserverInit = 'true';

    const observer = new MutationObserver(function () {
      rebuyCartScheduleLeadTimeRender();
    });

    observer.observe(cart, { childList: true, subtree: true });
    rebuyCartScheduleLeadTimeRender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCartLeadTimeObserver();
      if (isSmartCartEnabled()) initCartVisibilityObserver();
    });
  } else if (isSmartCartEnabled()) {
    initCartLeadTimeObserver();
    initCartVisibilityObserver();
  } else {
    initCartLeadTimeObserver();
  }
})();
